var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZeroFranschize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 85,
    viewBox: "0 0 88 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.5469 12.9015C76.7807 26.1353 83.8601 55.7602 70.6263 68.994C57.3925 82.2279 28.3119 78.9603 15.0781 65.7265C1.84422 52.4927 18.8978 31.7522 32.1316 18.5184C45.3655 5.28454 50.3131 -0.332331 63.5469 12.9015Z",
    fill: "#F7F8F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6244 59.7216C48.2273 60.9605 39.6668 54.8249 35.5613 51.6023C33.2262 48.2653 29.9136 41.0114 35.344 38.6918C40.7743 36.3722 44.245 40.99 45.3016 43.5889C47.0239 40.6058 51.747 35.3778 56.8608 38.3302C61.9746 41.2827 60.6336 44.3434 59.2924 47.4046L59.2924 47.4048C56.6101 53.5268 51.3708 58.173 49.6244 59.7216Z",
    stroke: "#3D3935",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeroFranschize);
export default __webpack_public_path__ + "static/media/zero-franschize.01bbfd8ae0e983cf292937a5d5b7c593.svg";
export { ForwardRef as ReactComponent };